// src/pages/Primary.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Primary() {
  const navigate = useNavigate();

  const classes = [
    { id: "class1", name: "Class 1" },
    { id: "class2", name: "Class 2" },
    { id: "class3", name: "Class 3" },
    { id: "class4", name: "Class 4" },
  ];

  return (
    <div className="min-h-screen p-6 bg-green-50">
      <h1 className="text-3xl font-bold mb-6 text-center">
        Primary (Grades 1–4)
      </h1>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {classes.map((cls) => (
          <div
            key={cls.id}
            onClick={() => navigate(`/primary/${cls.id}`)}
            className="bg-white p-6 rounded-xl shadow cursor-pointer hover:shadow-lg transition"
          >
            <h2 className="text-2xl font-semibold text-center">
              {cls.name}
            </h2>
          </div>
        ))}
      </div>
    </div>
  );
}








